export const COOLANT_QUESTIONS = [
  {
    label: "In Radiator is filled with",
    options: [
      { label: "Coolant", apiOptionKey: "collant" },
      {
        label: "Water",
        apiOptionKey: "water",
      },
      {
        label: "Photos",
        apiOptionKey: "attachments",
      },
    ],
  },

  {
    label: "Coolant Information",
    options: [
      {
        label: "Coolant make",
        type: "INPUT",
        apiOptionKey: "collantmake",
      },
      {
        label: "Coolant PH value",
        type: "INPUT",
        apiOptionKey: "coolantPHValue",
      },
      {
        label: "% of coolant / Additive with respect to RO water",
        type: "INPUT",
        apiOptionKey: "percentOfCoolantOrAdditiveWithRespectToROWater",
      },
    ],
  },

  {
    label: "Coolant level observed in recovery tank",
    type: "RADIO",
    apiKey: "coolantLevelObservedInRecoveryTank",
    options: [
      {
        label: "UPTO MAX MARK",
        apiOptionKey: "foundAirInFuelSystem",
        value: "UPTO_MAX_MARK",
      },
      {
        label: "UPTO MIN MARK",
        apiOptionKey: "foundLowPressurePipeBlocked",
        value: "UPTO_MIN_MARK",
      },
      {
        label: "BETWEEN MIN AND MAX MARK",
        apiOptionKey: "foundLowpressurePipeBend",
        value: "BETWEEN_MIN_AND_MAX_MARK",
      },
      {
        label: "NO COOLANT",
        apiOptionKey: "foundFuelHoseBanjoWasherDamage",
        value: "NO_COOLANT",
      },
    ],
  },
  {
    label: "Coolant level in Radiator",
    apiKey: "coolantLevelInRadiator",
    type: "RADIO",
    options: [
      { label: "UPTO NECK", apiOptionKey: "UPTO_NECK", value: "UPTO_NECK" },
      {
        label: "SLIGHTLY BELOW NECK",
        apiOptionKey: "SLIGHTLY_BELOW_NECK",
        value: "SLIGHTLY_BELOW_NECK",
      },
      { label: "NO COOLANT", apiOptionKey: "NO_COOLANT", value: "NO_COOLANT" },
    ],
  },
  {
    label: "Radiator condition",
    options: [
      { label: "Found Good", apiOptionKey: "foundGood" },
      { label: "Found Fins damaged", apiOptionKey: "foundFinsDamaged" },
      { label: "Found Fins clogged", apiOptionKey: "foundFinsClogged" },
      { label: "Found core leakage", apiOptionKey: "foundCoreLeakage" },
      { label: "Found muddy in core", apiOptionKey: "foundMuddyInCore" },
    ],
  },
  {
    label: "Coolant Temperature in OC",
    type: "INPUT",
    apiKey: "coolantTempratureInOC",
    options: [],
  },
  {
    label: "Thermostat Condition",
    options: [
      { label: "Found ok", apiOptionKey: "q7o1" },
      { label: "Found struck open", apiOptionKey: "foundStruckOpen" },
      { label: "Found struck closed", apiOptionKey: "foundStruckClosed" },
      {
        label: "Physical damage observed",
        apiOptionKey: "physicalDamageObserved",
      },
      {
        label: "Discoloration observed",
        apiOptionKey: "discolorationObserved",
      },
      {
        label: "Opening Temperature in Temperature in OC",
        apiOptionKey: "openingTempratureInOc",
        type: "INPUT",
      },
    ],
  },
  {
    label: "Water Pump condition",
    options: [
      { label: "Found ok", apiOptionKey: "q8o1" },
      {
        label: "Found Coolant leakage from weep hole",
        apiOptionKey: "foundCoolantLeakageFromWeepHole",
      },
      {
        label: "Found casting blockage",
        apiOptionKey: "foundCastingBlockage",
      },
    ],
  },
  {
    label: "Coolant hose condition",
    options: [
      { label: "Found ok", apiOptionKey: "q9o1" },
      {
        label: "Found puncture / damage",
        apiOptionKey: "foundPunctureOrDamage",
      },
      { label: "Found blockage", apiOptionKey: "foundBlockage" },
      { label: "Found Clamping loose", apiOptionKey: "foundClampingLoose" },
    ],
  },
  {
    label: "Coolant Flow",
    options: [
      { label: "Free flow observed", apiOptionKey: "freeFlowObserved" },
      {
        label: "Casting blockage in Inlet connection",
        apiOptionKey: "castingBlockageInInletConnection",
      },
      {
        label: "Casting blockage in Cylinder block",
        apiOptionKey: "castingBlockageInCylinderBlock",
      },
    ],
  },
  {
    label: "Condition of Fan belt",
    options: [
      { label: "Found 10 mm deflection", apiOptionKey: "foundTenMMDeflection" },
      { label: "Found very tight", apiOptionKey: "foundVeryTight" },
      { label: "Found loose fitted", apiOptionKey: "foundLoseFitted" },
    ],
  },
  {
    label: "Condition of Radiator Pressure Cap",
    options: [
      { label: "Found OK", apiOptionKey: "q1001" },
      { label: "Found Missing", apiOptionKey: "foundMissing" },
      { label: "Found faulty", apiOptionKey: "foundFaulty" },
    ],
  },
];

export const mappingCoolantDetailsToUI = (details) => {
  const {
    inRadiatorIsFilledWith,
    radiatorCondition,
    thermostatCondition,
    waterPumpCondition,
    coolantHoseCondition,
    coolantFlow,
    conditionOfFanBelt,
    conditionOfRadiatorPressureCap,
  } = details;

  let responseDetails = {
    collant: inRadiatorIsFilledWith?.collant,
    water: inRadiatorIsFilledWith?.water,

    collantmake: details.collantmake,
    coolantPHValue: details.coolantPHValue,
    percentOfCoolantOrAdditiveWithRespectToROWater:
      details.percentOfCoolantOrAdditiveWithRespectToROWater,

    coolantLevelObservedInRecoveryTank:
      details.coolantLevelObservedInRecoveryTank,
    coolantLevelInRadiator: details.coolantLevelInRadiator,

    foundGood: radiatorCondition?.foundGood,
    foundFinsDamaged: radiatorCondition?.foundFinsDamaged,
    foundFinsClogged: radiatorCondition?.foundFinsClogged,
    foundCoreLeakage: radiatorCondition?.foundCoreLeakage,
    foundMuddyInCore: radiatorCondition?.foundMuddyInCore,

    coolantTempratureInOC: details.coolantTempratureInOC,

    q7o1: thermostatCondition?.foundOk,
    foundStruckOpen: thermostatCondition?.foundStruckOpen,
    foundStruckClosed: thermostatCondition?.foundStruckClosed,
    physicalDamageObserved: thermostatCondition?.physicalDamageObserved,
    discolorationObserved: thermostatCondition?.discolorationObserved,
    openingTempratureInOc: thermostatCondition?.openingTempratureInOc,

    q8o1: waterPumpCondition?.foundOk,
    foundCoolantLeakageFromWeepHole:
      waterPumpCondition?.foundCoolantLeakageFromWeepHole,
    foundCastingBlockage: waterPumpCondition?.foundCastingBlockage,

    q9o1: coolantHoseCondition?.foundOk,
    foundPunctureOrDamage: coolantHoseCondition?.foundPunctureOrDamage,
    foundBlockage: coolantHoseCondition?.foundBlockage,
    foundClampingLoose: coolantHoseCondition?.foundClampingLoose,

    freeFlowObserved: coolantFlow?.freeFlowObserved,
    castingBlockageInInletConnection:
      coolantFlow?.castingBlockageInInletConnection,
    castingBlockageInCylinderBlock: coolantFlow?.castingBlockageInCylinderBlock,

    foundTenMMDeflection: conditionOfFanBelt?.foundTenMMDeflection,
    foundVeryTight: conditionOfFanBelt?.foundVeryTight,
    foundLoseFitted: conditionOfFanBelt?.foundLoseFitted,

    q1001: conditionOfRadiatorPressureCap?.foundOk,
    foundMissing: conditionOfRadiatorPressureCap?.foundMissing,
    foundFaulty: conditionOfRadiatorPressureCap?.foundMissing,
  };

  return responseDetails;
};
